var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-tooltip',{attrs:{"content":_vm.getServiceName}},[_c('span',{class:_vm.getIconStyle,attrs:{"slot":"buttonContent"},slot:"buttonContent"})])
}
var staticRenderFns = []

export { render, staticRenderFns }